import { z } from 'zod';
import { imageSchema, directoryScheme } from '.';

export const imageFileArrayHelperText =
  imageSchema.createImageFileArrayHelperText({
    maxFiles: 5,
    required: false,
  });
export const imageFileArraySchema = imageSchema.createImageFileArraySchema({
  maxFiles: 5,
  required: false,
});

export const gradeHelperText =
  'Grade is required. Please choose either Pass or Fail';
export const gradeSchema = z.enum(['pass', 'fail'], {
  message: gradeHelperText,
});

export const descriptionHelperText = directoryScheme.createTextFieldHelperText({
  name: 'Description',
  minLength: 0,
  required: false,
});
export const descriptionSchema = directoryScheme.createTextFieldSchema({
  name: 'Description',
  minLength: 0,
  required: false,
});

export const correctiveActionHelperText =
  directoryScheme.createTextFieldHelperText({
    name: 'Corrective Action',
    minLength: 0,
    required: false,
  });
export const correctiveActionSchema = directoryScheme.createTextFieldSchema({
  name: 'Corrective Action',
  minLength: 0,
  required: false,
});
